import {
  PiListMagnifyingGlass,
  PiNotepadBold,
  PiUserCircle,
  PiUsers,
  PiYoutubeLogo,
} from 'react-icons/pi';
import { INavbarItem } from 'types/navbar/navbar.interface';

export const navbarItems: INavbarItem[] = [
  // {
  //   path: '',
  //   name: 'home',
  //   icon: PiHouseLine,
  // },
  {
    path: 'account',
    icon: PiUserCircle,
  },
  {
    path: 'statements',
    icon: PiNotepadBold,
    name: 'statements',
  },
  {
    path: 'watchlist',
    icon: PiListMagnifyingGlass,
    name: 'watchlist',
  },
  {
    path: 'youtube-oauth',
    icon: PiYoutubeLogo,
    name: 'youtubeOAuth',
  },
  {
    path: 'users',
    icon: PiUsers,
    name: 'users',
  },
];
